<template>
  <!-- 章节练习 -->
  <div class="uni-practice">
    <div class="content-box">
      <!-- 章节列表 -->
      <ul class="head-box">
        <li class="item">课程名称</li>
        <li class="item">上次练习时间</li>
        <li class="item">做题情况</li>
        <li class="item">操作</li>
      </ul>

      <ComponentCollapse
        v-for="item in majorList"
        ref="component"
        :title="item.title"
        class="collapse-box"
        :key="item.id"
        :name="item.id"
        :activeNames="activeNames"
      >
        <div class="title-right" slot="title-right">
          <el-progress :percentage="item.ratio"></el-progress>
        </div>

        <ul
          slot="collapseContent"
          class="collapse-cell"
          v-for="course in item.node"
          :key="course.id"
        >
          <li class="item">
            <i
              class="iconfont icongouxuan primary"
              v-if="course.make_record"
            ></i>
            <!-- 占位 -->
            <el-progress
              v-else
              style="vertical-align: middle; margin-right: 10px"
              :width="20"
              :strokeWidth="0"
              type="circle"
              :percentage="0"
              :show-text="false"
            ></el-progress>
            <span class="span tit">{{ course.title }}</span>
          </li>
          <li class="item">
            {{ (course.make_record && course.make_record.created_at) || "--" }}
          </li>
          <li class="item">
            <span v-if="course.practice_num>0 && course.subject_total>0">已做：{{ course.fulfil_number || 0 }}/总题：{{ course.subject_total || 0 }}</span>
            <span v-else>--</span>
          </li>
          <li class="item">
            <template v-if="course.practice_num > 0">
              <span
                :class="
                  course.task_status === 1 ? 'success' : ''
                "
                >{{
                  course.task_status === 1
                    ? "已完成"
                    : "未完成"
                }}</span
              >
<!--              <el-button
                v-if="(course.task_status === 0 && course.learn_status === 1 && courseList.is_hours_complete === 1) || (course.task_status === 0  && courseList.is_hours_complete === 0)"
                @click="jump('startPractice', course)"
                class="uni-link-btn"
                type="primary"
                icon="el-icon-video-play"
                >{{
                  course.task_status === 0
                    ? "开始练习"
                    : "继续练习"
                }}</el-button
              >
              <span class="color_999" v-else>未完成学习</span>         -->

              <el-button
                v-if="course.learn_status === 1 && courseList.is_hours_complete === 1"
                @click="jump('startPractice', course)"
                class="uni-link-btn"
                type="primary"
                icon="el-icon-video-play"
              >开始练习</el-button>
              <el-button
                v-if="courseList.is_hours_complete === 0"
                @click="jump('startPractice', course)"
                class="uni-link-btn"
                type="primary"
                icon="el-icon-video-play"
              >开始练习</el-button>
              <span class="color_999" v-if="course.learn_status === 0 && courseList.is_hours_complete === 1">未完成学习</span>

            </template>

            <div class="gray" v-else>无作业练习</div>
          </li>
        </ul>
      </ComponentCollapse>

      <ComponentEmpty tips title="暂无作业进度" v-if="majorList.length == 0" />
    </div>
  </div>
</template>

<script>
import ComponentCollapse from "@/components/componentCollapse";
import { getPracticeList } from "@/api/basic";
export default {
  name: "uni-practice",
  components: {
    ComponentCollapse,
  },
  props: {
    courseUuid: {
      type: [String, Number],
    },
  },
  watch: {
    courseUuid(val) {
      this.getSections(val);
    },
  },
  data() {
    return {
      type: 2,
      activeNames: [],
      majorList: [],
      courseList:[],
    };
  },
  created() {
    // if (this.courseUuid) {
    //   console.log(22222)
    //   this.getSections(this.courseUuid);
    // }
  },
  methods: {
    // 章节列表
    async getSections(course_id) {

      if(this.$base.isNull(course_id))return
      const params = {
        course_id: course_id,
      };
      this.majorList = [];
      const res = await getPracticeList(params);
      if (res.code == 200) {
        this.majorList = res.result.list;
        this.courseList = res.result.course_info;
        //console.log(this.courseList.is_hours_complete);
        if(this.majorList.length > 0) {
          this.activeNames.push(this.majorList[0].id);
        }
      }
    },
    // 页面跳转
    jump(name, course) {
      // 做练习
      this.$router.push({
        name: name,
        query: {
          course_id: course.course_id,
          section_id: course.id,
        },
      });
    },
  },
};
</script>

<style lang="scss">
.collapse-box {
  .header {
    background: #f8f9fb;
  }
  .title-right {
    width: 180px;
  }
}
</style>
<style lang="scss" scoped>
.uni-practice {
  // padding: $sideMargin;
  padding-bottom: 0;
  min-height: $menuH;

  .filter-box {
    background: #fff;

    .tit {
      width: 100px;
      font-size: 16px;
      font-weight: 600;
    }

    .con {
      flex: 1;
    }

    .filter-list {
      .item {
        display: flex;
        border-bottom: 1px solid $grayBorder;
        padding: 20px;

        &:last-child {
          border: none;
        }
      }

      .course {
        border: 0;
        margin: 5px 10px 5px 0;

        &.active {
          @include fontColor("primary");
          @include bgColor("active-color");
          border-color: #c0cdff;
        }
      }
    }
  }

  .content-box {
    background: #fff;
    // margin-top: 10px;
    // padding: 20px;

    .title-box {
      display: flex;
      justify-content: space-between;
      align-items: center;

      .total {
        display: flex;
        align-items: center;
        justify-content: space-between;
      }
    }

    .head-box {
      display: flex;
      height: 40px;
      line-height: 40px;
      @include bgColor("primary-lighten");
      color: #fff;
      margin-top: 25px;
      margin-bottom: 25px;

      .item {
        height: 100%;
        border-right: 1px solid #fff;
        flex: 1;
        text-align: center;

        &:nth-child(1) {
          flex: 2;
        }

        &:last-child {
          border-right: 0;
        }
      }
    }

    .collapse-cell {
      display: flex;
      align-items: center;
      padding: 20px 20px 20px 70px;

      .iconfont {
        vertical-align: middle;
        font-size: 20px;
        margin-right: 10px;
      }

      .item {
        flex: 1;
        text-align: center;
        &:nth-child(1) {
          text-align: left;
          flex: 2;
        }
      }

      .uni-link-btn {
        @include uni-link-btn(90px);
        margin-left: 40px;
      }
      .color_999{
        background-color: #ccc !important;
        padding: 4px 8px;
        border-radius: 10px;
        margin-left: 40px;
        color: #fff;
      }
    }
  }
}
</style>
